import { RequestPayload } from "appworks/model/gameplay/requests/request-payload";

export class GambleInitRequestPayload extends RequestPayload {
    public gambleID: number;
    public stake: number;
}
